// extracted by mini-css-extract-plugin
export default {"root":"FXOhOT","button":"dmODW9"};